import React from 'react';
import AppTable from "components/Shared/AppTable";
import { useTablePagination } from "hooks";
import { useDriverDetailContext } from "contexts/DriverDetailContext";
import { useListPaymentPricesByDriverIdQuery } from "store/services/driverApi";
import AppTableDateTime from "components/Shared/AppTableDateTime";
import { Chip } from "@mui/material";

const DriverPaymentList = () => {

    const { driverDetail } = useDriverDetailContext();
    const {
        currentPage,
        perPage,
        handlePageChange,
        handlePerRowsChange,
    } = useTablePagination();

    const { data: response, isLoading, isFetching } = useListPaymentPricesByDriverIdQuery({
        driverId: driverDetail?._id,
        page: currentPage,
        limit: perPage,
    });
    const columns = [
        {
            name: "Shipment ID",
            selector: (row) => row?.shipmentId,
            cell: (row) => row?.shipmentId,
        },
        {
            name: "Payment Type",
            selector: (row) => row?.feeItem?.name || "-",
        },
        {
            name: "Amount",
            selector: (row) => row?.charge,
            cell: (row) => `Rs. ${row?.charge?.toFixed(2)}`,
        },
        {
            name: "Charge Type",
            selector: (row) => row?.chargeType,
        },
        {
            name: "Payer",
            selector: (row) => row?.payer,
        },
        {
            name: "Payment Location",
            selector: (row) => row?.paymentLocation,
        },
        {
            name: "User",
            selector: (row) => row?.user?.name,
        },
        {
            name: "Status",
            selector: (row) => row?.paymentStatus,
            cell: (row) => {
                const status = row?.paymentStatus || "N/A";
                const isPositive = status === "Paid";

                return (
                    <Chip
                        label={status}
                        sx={{
                            backgroundColor: isPositive ? "#e6f4ea" : "#ffeaea", // green or red background
                            color: isPositive ? "#2e7d32" : "#c62828",           // green or red text
                            fontWeight: "bold",
                            height: 20,
                            borderRadius: "12px",
                            padding: 0,
                            "& .MuiChip-label": {
                                fontSize: "0.625rem",
                                padding: "2px 6px",
                                lineHeight: 1,
                            },
                        }}
                    />
                );
            },
            sortable: true,
        },
        {
            name: "Created At",
            selector: (row) => row?.createdAt || "",
            cell: (row) => <AppTableDateTime date={row?.createdAt} />,
            sortable: true,
        },
        {
            name: "Updated At",
            selector: (row) => row?.updatedAt || "",
            cell: (row) => <AppTableDateTime date={row?.updatedAt} />,
            sortable: true,
        },

    ];

    return (
        <div>
            <AppTable
                columns={columns}
                data={response?.data ?? []}
                progressPending={isLoading || isFetching}
                paginationServer
                paginationPerPage={perPage}
                paginationTotalRows={response?.totalItems ?? 0}
                paginationDefaultPage={currentPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
            />
        </div>
    );
};

export default DriverPaymentList;
